<template>
  <section class="content">
    <admin-header
      :title="'Request For Proposals'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:entity-quick-search="search"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    name: 'AdminRequestForProposal',
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    data () {
      return {
        newEntityScreen: 'Admin - Request For Proposals',
        searchEntityScreen: 'Admin - Request For Proposal search',
        filterEventName: 'admin-request-for-proposal-filter',
        filterName: 'RequestForProposalFilter',
        entityName: 'request-for-proposal'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/RequestForProposal/AdminRequestForProposal.vue